import { format } from 'date-fns';

// Types
import { CountryCode } from '../../types/lang/language';

// Services
import { formatOptions } from './configuration';

export const toShortDate = (date: string, countryCode?: CountryCode) => {
  const { shortDate } = formatOptions(countryCode);
  return format(new Date(date), shortDate);
};

export const toDayMonthTime = (date: string, countryCode?: CountryCode) => {
  const { dayMonthTime } = formatOptions(countryCode);
  return format(new Date(date), dayMonthTime);
};

export const toDateTime = (date: string, countryCode?: CountryCode) => {
  const { dateTime } = formatOptions(countryCode);
  return format(new Date(date), dateTime);
};

export const toFullDateTime = (date: string, countryCode?: CountryCode) => {
  const { fullDateTime } = formatOptions(countryCode);
  return format(new Date(date), fullDateTime);
};

export const toTime = (date: string, countryCode?: CountryCode) => {
  const { time } = formatOptions(countryCode);
  return format(new Date(date), time);
};
